<div *ngIf="hasSmartChargePlan && !isCharging">
  <div>
    <p>
      Hvis du ikke ønsker å smartlade etter planen kan du trykke på denne
      knappen for å starte ladingen umiddelbart.
    </p>
  </div>
  <ion-button
    class="smart-charge"
    [class.disabled]="planOverridden"
    (click)="smartChargeOverride()"
    [disabled]="planOverridden"
  >
    <img src="assets/img/enode/lightning.svg" />
    <p>Start lading nå</p>
  </ion-button>
</div>

<div *ngIf="isOverridden">
  <div>
    <p>
      Hvis du ønsker å gjenoppta smartlading kan du trykke på denne knappen og
      gå tilbake til den opprinnelige ladeplanen.
    </p>
  </div>
  <ion-button
    class="smart-charge resume"
    (click)="resumeSmartCharge()"
    [disabled]="resumingPlan"
  >
    <ion-icon name="arrow-back-outline"></ion-icon>
    <p>Gjenoppta ladeplan</p>
  </ion-button>
</div>

<div *ngIf="chargeFailed || resumeFailed" class="error">
  <ion-icon
    class="error-icon"
    color="danger"
    name="alert-circle-outline"
  ></ion-icon>
  <div class="error-message">
    <p>
      {{
        chargeFailed
          ? 'Det oppsto en feil ved start av lading.'
          : 'Det oppsto en feil ved å gjennoppta ladeplanen.'
      }}
    </p>
    <p>Vennligst prøv igjen.</p>
  </div>
</div>
